<template>
  <div :id="productId ? `product-card-${productId}` : 'product-card'" :class="{ border: showBorder }">
    <ProductThumbnail
      class="cell auto"
      alignment="horizontal"
      :image-width="imageWidth"
      :product="transformedProduct"
      :click-action="clickAction"
      :url-template="getUrlTemplate"
    />
    <slot></slot>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import ProductThumbnail from '@/features/ProductThumbnail/components/ProductThumbnail';

const props = defineProps({
  product: {
    type: Object,
    default: () => {},
  },
  productId: {
    type: String,
    default: '',
  },
  clickAction: {
    type: String,
    default: 'disabled',
    validator: (val) => ['linkToPdp', 'disabled', 'fireEvent'].includes(val),
  },
  imageWidth: {
    type: Number,
    default: 80,
  },
  transformer: {
    type: Function,
    default: (product) => product,
  },
  urlTemplate: {
    type: String,
    default: '',
  },
  showBorder: {
    type: Boolean,
    default: false,
  },
});

const transformedProduct = computed(() => (props.transformer ? props.transformer(JSON.parse(JSON.stringify(props.product))) : props.product));
const getUrlTemplate = computed(() => {
  const url = props.product.itemDetails?.urlTemplate || props.urlTemplate;
  return url ? { product: url } : {};
});
</script>

<style lang="scss" scoped>
.border {
  border: $black-border;
}
</style>
